<template>
  <PForm nested :schema="r$" :validate-on="['blur', 'input']">
    <PFormField
      label="E-mailadressen"
      sr-only
      name="emails"
      help="Voer extra e-mailadressen in, gescheiden door puntkomma's."
    >
      <PTextarea
        autoresize
        v-model="modelValue.emails"
        placeholder="E-mailadressen"
        @input="delayedUpdate.schedule()"
      />
    </PFormField>

    <AutoUpdateStatus
      :is-updating="isSaving"
      :error-encountered="errorEncountered"
      :time-hide-after-success="2000"
    />
  </PForm>
</template>

<script setup lang="ts">
import PForm from "@/components/form/PForm.vue"
import { computed, ref } from "vue"
import type { RoleFinancialOfficer } from "@/models/role/role-financial-officer.model"
import { useRoleStore } from "@/store/roles.store"
import useDelayedFunction from "@/composables/input/delayed-function"
import { useRegle } from "@regle/core"
import { multipleEmailsValidator } from "@/helper/validation/validators"
import AutoUpdateStatus from "@/components/instruction/AutoUpdateStatus.vue"
import PTextarea from "@/components/form/PTextarea.vue"
import PFormField from "@/components/form/PFormField.vue"

const modelValue = defineModel<RoleFinancialOfficer>({ required: true })

const emit = defineEmits(["roleChanged"])

const roleStore = useRoleStore()

const delayedUpdate = useDelayedFunction(updateRole, 500)

const isSaving = ref(false)
const errorEncountered = ref(false)
async function updateRole() {
  errorEncountered.value = false
  if (r$.emails.$invalid) {
    return
  }

  isSaving.value = true
  const response = await roleStore.updateRole(modelValue.value)
  if (response.status !== 200) {
    errorEncountered.value = true
  }
  emit("roleChanged")
  isSaving.value = false
}

const rules = {
  emails: { multipleEmailsValidator }
}
const { r$ } = useRegle(
  computed(() => ({ emails: modelValue.value.emails })),
  rules,
  { autoDirty: false }
)
</script>

<style scoped></style>
